import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { Notification } from 'is24-corecss'
import { FieldProps } from '../../../../../../../@types/types'
import { OtherFacilitiesScreenValidationResult } from '../../../../../../../@types/validation-types'
import EstateFeaturesYesOrNoChipOptionField from '../estateFeaturesYesOrNoChipOptionField/EstateFeaturesYesOrNoChipOptionField'

export interface CertificateOfEligibilityNeededProps extends FieldProps<OtherFacilitiesScreenValidationResult> {
  showTooltip?: boolean
  showPopoverTooltip?: boolean
}

export const CertificateOfEligibilityNeeded: React.FC<CertificateOfEligibilityNeededProps> = ({
  insertionData,
  screenName,
  wrapperClassName = 'grid-item one-whole',
  onChange,
}) => {
  const { t } = useTranslation()

  const initialWBSValue = useRef(insertionData.estateFeatures?.certificateOfEligibilityNeeded === true)

  // The WBS option should not be editable if user already has a running contract when it is already selected
  // the flag addressEditable is appropriate here because it has the same logic behind as the address editability
  // see https://github.com/Scout24/central-listings-backend/blob/main/src/main/java/de/is24/offer/hof/infrastructure/utils/AddressEditabilityUtils.kt
  const isWBSDisabled =
    insertionData.addressEditable != undefined && !insertionData.addressEditable && initialWBSValue.current

  const certificateOfEligibilityNeeded = insertionData.estateFeatures?.certificateOfEligibilityNeeded

  return (
    <div className={wrapperClassName}>
      <EstateFeaturesYesOrNoChipOptionField
        id='wbs-required'
        labelTranslationKey={'wizard.screen.objectDetails.wbsRequired'}
        estateFeatureKey='certificateOfEligibilityNeeded'
        screenName={screenName}
        insertionData={insertionData}
        onChange={onChange}
        disabled={isWBSDisabled}
      />
      {certificateOfEligibilityNeeded && (
        <div className={`grid-item one-whole margin-top-l`}>
          <Notification.Root type='info' variant='flat'>
            <Notification.Icon />
            <Notification.Content>
              <Notification.Message>{t('statusMessage.messages.wbsNotice')}</Notification.Message>
            </Notification.Content>
          </Notification.Root>
        </div>
      )}
    </div>
  )
}
